(() => {
  if(customElements.get('ff-scenarios-nav'))return;
  class FFScenariosNav extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.details=this.querySelector('[data-scenario-disclosure]');
      this.trigger=this.querySelector('[data-scenario-trigger]');
      this.tabs=[...this.querySelectorAll('[data-scenario-tab]')];
      this.panels=[...this.querySelectorAll('[data-scenario-panel]')];
      this.hover=matchMedia('(min-width:1150px) and (hover:hover) and (pointer:fine)');
      const on=(target,event,fn)=>target.addEventListener(event,fn,{signal});
      const update=()=>this.trigger.setAttribute('aria-expanded',String(this.details.open));
      on(this.details,'toggle',update);
      on(this,'pointerenter',()=>{clearTimeout(this.closeTimer);if(this.hover.matches)this.openTimer=setTimeout(()=>{this.details.open=true;update();},90);});
      on(this,'pointerleave',()=>{clearTimeout(this.openTimer);if(this.hover.matches)this.closeTimer=setTimeout(()=>this.close(false),180);});
      on(this,'focusout',event=>{if(!this.contains(event.relatedTarget))this.close(false);});
      on(document,'pointerdown',event=>{if(!this.contains(event.target))this.close(false);});
      on(this,'keydown',event=>{
        if(event.key==='Escape'&&this.details.open){event.preventDefault();event.stopPropagation();this.close(true);}
        const tab=event.target.closest('[data-scenario-tab]');
        if(!tab)return;
        let next=this.tabs.indexOf(tab);
        if(event.key==='ArrowDown')next=(next+1)%this.tabs.length;
        else if(event.key==='ArrowUp')next=(next+this.tabs.length-1)%this.tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=this.tabs.length-1;
        else return;
        event.preventDefault();this.activate(this.tabs[next]);this.tabs[next].focus();
      });
      on(this.querySelector('[data-scenario-close]'),'click',()=>this.close(true));
      this.tabs.forEach(tab=>{
        on(tab,'click',()=>this.activate(tab));
        on(tab,'pointerenter',()=>{if(this.hover.matches)this.activate(tab);});
      });
      this.resize=()=>{if(innerWidth<1150)this.close(false);};
      on(window,'resize',this.resize);
      update();
    }
    activate(tab){
      this.tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
      this.panels.forEach(p=>p.hidden=p.dataset.scenarioPanel!==tab.dataset.scenarioTab);
    }
    close(focus){
      clearTimeout(this.openTimer);clearTimeout(this.closeTimer);
      this.details.open=false;
      this.trigger.setAttribute('aria-expanded','false');
      if(focus)this.trigger.focus();
    }
    disconnectedCallback(){clearTimeout(this.openTimer);clearTimeout(this.closeTimer);this.abort?.abort();}
  }
  customElements.define('ff-scenarios-nav',FFScenariosNav);
})();

